import clsx from "clsx"
import React from "react"

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  headingLevel: "banner" | "title" | "h3" | "subtitle"
}

export const Heading = ({ headingLevel, className, ...props }: HeadingProps) => {
  switch (headingLevel) {
    case "banner":
      return (
        <h1
          className={clsx(
            className,
            "sm:text-banner font-semibold sm:leading-[46px]",
            "text-xl leading-[30px]"
          )}
          {...props}
        />
      )
    case "title":
      return (
        <h2
          className={clsx(
            className,
            "sm:text-title sm:leading-[38px] font-semibold",
            "text-lg leading-[26px]"
          )}
          {...props}
        />
      )
    case "h3":
      return (
        <h3
          className={clsx(className, "sm:text-lg text-blue font-semibold leading-7", "text-sm")}
          {...props}
        />
      )
    case "subtitle":
      return <div className={clsx(className, "text-black-67 sm-only:text-xs")} {...props} />

    default:
      return <></>
  }
}
